import { isValidAnswer } from '../../helpers/answer_helper';
import { hasMatchedCondition } from '../../helpers/logic_helper';

export const selectInvalidQuestions = ({ questions, answers }) => {
  return questions.filter((question) => !isValidAnswer(question, answers[question.id]));
};

export const selectHasMetSurveyRequirements = ({ questions, answers }) => {
  if (questions.length === 0) return false;

  return questions.reduce((surveyIsValid, question) => {
    const isNotVisible =
      question.displayConditions &&
      question.displayConditions.length > 0 &&
      !hasMatchedCondition(question.displayConditions, answers);
    if (isNotVisible) return surveyIsValid;
    return surveyIsValid && isValidAnswer(question, answers[question.id]);
  }, true);
};
